export default "__VITE_ASSET__37dd926e__"